<template>
  <div class="my-l">
    <div v-if="mainEntry && mainEntry[0]" class="container flex flex-row items-baseline justify-between">
      <h2 class="mr-auto fluid-3xl leading-tightest">{{ mainEntry[0].title }}</h2>
      <CtaArrow :to="allArticlesRoute" class="text-blackly block font-medium mt-4">{{
        $t('knowledge.allTopicArticles', { title: mainEntry[0].title })
      }}</CtaArrow>
    </div>

    <div class="sm:container sm:flex-row sm:space-x-8 flex flex-col px-0 mt-6">
      <div class="w-full sm:w-1/2">
        <div v-if="feature" class="sm:pr-8 sm:pb-12 lg:pb-18 sticky pb-16" style="top: 6rem">
          <FixedAspect :ratio="5 / 4">
            <CldnImg
              v-if="feature.image[0]"
              :src="feature.image[0].url"
              :alt="feature.image[0].title"
              sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
              crop="fill"
              class="max-w-none absolute inset-0 z-0 block object-cover w-full h-full"
            />
          </FixedAspect>

          <div class="relative">
            <div class="box-thin ml-6 -mt-12 lg:ml-12 lg:-mr-12 lg:-mt-24 z-10">
              <div class="flex flex-row items-center space-x-4">
                <TagBtn
                  v-if="feature.topics[0]"
                  :to="{
                    name: `knowledge-index-topic___${$i18n.locale}`,
                    params: { topic: feature.topics[0].slug },
                  }"
                >
                  {{ feature.topics[0].title }}
                </TagBtn>
                <TagBtn
                  v-if="feature.categories[0]"
                  :to="{
                    name: `knowledge-index-category-slug___${$i18n.locale}`,
                    params: { slug: feature.categories[0].slug },
                  }"
                  secondary
                >
                  {{ feature.categories[0].title }}
                </TagBtn>
                <div class="fluid-xs leading-tightest font-medium">
                  {{ $t('readTime', { min: feature.readTime }) }}
                </div>
              </div>

              <h3 class="mt-4 fluid-xl leading-tight font-medium lg:fluid-3xl leading-tightest">{{ feature.title }}</h3>
              <div class="mt-4 fluid-lg font-light leading-normal" v-html="feature.teaserText"></div>
              <nuxt-link
                :to="{
                  name: `article-slug___${$i18n.locale}`,
                  params: { slug: feature.slug },
                }"
                class="btn-pill-black inline-block mt-4"
                >{{ $t('readMore') }}</nuxt-link
              >
            </div>
          </div>
        </div>
      </div>
      <div class="sm:space-y-8 w-ful sm:w-1/2 flex flex-col">
        <ArticlePreview v-for="article in articles" :key="article.id" :article="article" horizontal />
      </div>
    </div>
  </div>
</template>

<script>
import ArticlePreview from '@/components/article/ArticlePreview';
import CtaArrow from '@/components/common/CtaArrow';
import FixedAspect from '@/components/common/FixedAspect';
import CldnImg from '@/components/CldnImg';
import TagBtn from '@/components/common/TagBtn';

export default defineNuxtComponent({
  components: {
    ArticlePreview,
    TagBtn,
    CtaArrow,
    FixedAspect,
    CldnImg,
  },
  props: {
    mainEntry: {
      type: Array,
      default: () => [],
    },
    featuredArticle: {
      type: Array,
      default: () => [],
    },
    featuredArticleImage: {
      type: Array,
      default: () => [],
    },
    featuredArticleTopic: {
      type: Array,
      default: () => [],
    },
    featuredArticleCategory: {
      type: Array,
      default: () => [],
    },
    articles: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    allArticlesRoute() {
      if (this.mainEntry && this.mainEntry[0]) {
        const entry = this.mainEntry[0];
        if (entry.typeHandle === 'topic') {
          return { name: `knowledge-index-topic-articles___${this.$i18n.locale}`, params: { topic: entry.slug } };
        } else if (entry.typeHandle === 'knowledgeCategories') {
          return { path: this.$localeRootPath(entry.uri) };
        }
      }
      return {};
    },
    feature() {
      if (this.featuredArticle && this.featuredArticle[0]) {
        const article = this.featuredArticle[0];
        if (this.featuredArticleImage && this.featuredArticleImage[0]) {
          article.image = this.featuredArticleImage;
        }
        if (this.featuredArticleTopic && this.featuredArticleTopic[0]) {
          article.topics = this.featuredArticleTopic;
        }
        if (this.featuredArticleCategory && this.featuredArticleCategory[0]) {
          article.categories = this.featuredArticleCategory;
        }
        return article;
      }
      return null;
    },
  },
});
</script>
